import SaturationData from '../domain/Saturation';
import ITransferRepository from '../domain/ITransferRepository';
import TransferRepository from '../infrastructure/repositories/TransferRepository';

class SaturationUseCase {
  private readonly _transferRepository: ITransferRepository;

  constructor({ transferRepository }) {
    this._transferRepository = transferRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._transferRepository
      .getSaturation({ queryParams })
      .then((res) => SaturationData.generateFromDTO(res));
  }
}

export default new SaturationUseCase({
  transferRepository: TransferRepository
});

export { SaturationUseCase };
